export default __webpack_public_path__ + "static/media/osh_qazili.e35621e0.png";